import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import VueI18n from 'vue-i18n';
import '@/assets/scss/general.scss';
import VueGtm from 'vue-gtm';
import settings from './settings/settings';

Vue.config.productionTip = false;

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'en'
});

const gtmid = settings.parameters.gtmid;
if (gtmid) {
  Vue.use(VueGtm, {
    id: gtmid,
    debug: false,
    vueRouter: router
  });
}

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#ezb');
